import { render, staticRenderFns } from "./InboundOrders.vue?vue&type=template&id=060b4912&scoped=true&lang=pug"
import script from "./InboundOrders.vue?vue&type=script&lang=js"
export * from "./InboundOrders.vue?vue&type=script&lang=js"
import style0 from "./InboundOrders.vue?vue&type=style&index=0&id=060b4912&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "060b4912",
  null
  
)

export default component.exports